<template>
  <form class="form" @submit.prevent="onSubmit()">
    <FormGroup :v="v$.subscribe_email" :label="null">
      <ToggleField
        id="subscribe_email"
        v-model="formValue.subscribe_email"
        :disabled="props.disabled"
      >
        {{ $t("subscriptionModal.emailLabel") }}
      </ToggleField>
    </FormGroup>
    <FormGroup :v="v$.subscribe_sms" :label="null">
      <ToggleField
        id="subscribe_sms"
        v-model="formValue.subscribe_sms"
        :disabled="props.disabled"
      >
        {{ $t("subscriptionModal.smsLabel") }}
      </ToggleField>
    </FormGroup>

    <FormGroup v-if="isPhoneRequired" :v="v$.phone" label="label.phone">
      <TextField
        v-model="formValue.phone"
        type="text"
        inputmode="phone"
        :disabled="props.disabled"
        placeholder="placeholder.phone"
        autocomplete="phone"
      />
    </FormGroup>

    <FormGroup :v="v$.subscribe_newsletter" :label="null">
      <ToggleField
        id="subscribe_newsletter"
        v-model="formValue.subscribe_newsletter"
        :disabled="props.disabled"
      >
        {{ $t("subscriptionModal.newsletterLabel") }}
      </ToggleField>
    </FormGroup>

    <FormGroup :v="v$.privacy_policy_agreed" label="">
      <CheckboxField v-model="formValue.privacy_policy_agreed" :disabled="props.disabled">
        <i18n-t keypath="user.agreePolicy" tag="span">
          <template #link>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">{{
              $t("user.agreePolicyLink")
            }}</a>
          </template>
        </i18n-t>
      </CheckboxField>
    </FormGroup>

    <AppButton type="submit" :loading="props.disabled">
      {{ $t("common.save") }}
    </AppButton>
  </form>
</template>

<script setup lang="ts">
import { computed, reactive } from "vue";
import FormGroup from "@/components/form/form-group.vue";
import TextField from "@/components/form/text-field.vue";
import { equal, phone } from "@/utils/validators";
import useVuelidate from "@vuelidate/core";
import AppButton from "@/components/app-button.vue";

import ToggleField from "@/components/form/toggle-field.vue";
import { CompleteRegistrationFormData } from "./models";
import { required } from "@vuelidate/validators";
import CheckboxField from "@/components/form/checkbox-field.vue";

const props = defineProps<{
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "submit", v: CompleteRegistrationFormData): void;
}>();

const formValue = reactive<CompleteRegistrationFormData>({
  subscribe_email: false,
  subscribe_sms: false,
  subscribe_newsletter: false,
  phone: "",
  privacy_policy_agreed: false,
});

const isPhoneRequired = computed(() => formValue.subscribe_sms);

const rules = computed(() => ({
  subscribe_email: {},
  subscribe_sms: {},
  subscribe_newsletter: {},
  privacy_policy_agreed: { privacy_policy_agreed: equal(true) },
  ...(isPhoneRequired.value ? { phone: { phone, required } } : {}),
}));

const v$ = useVuelidate(rules, formValue);

const onSubmit = () => {
  v$.value.$touch();

  if (!v$.value.$invalid) {
    emit("submit", {
      subscribe_email: formValue.subscribe_email,
      subscribe_sms: formValue.subscribe_sms,
      subscribe_newsletter: formValue.subscribe_newsletter,
      phone: isPhoneRequired.value ? formValue.phone : undefined,
      privacy_policy_agreed: formValue.privacy_policy_agreed,
    });
  }
};
</script>
